import React from 'react';
import { connect } from 'react-redux';
import { Field } from 'redux-form';
import { translate } from 'admin-on-rest';
import equal from 'deep-equal';
import { compose } from 'recompose';
import { get } from 'lodash';
import {
  MenuItem,
  SelectField,
} from 'material-ui';

const styles = {
  wrapper: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'start',
  },
};

const menuItems = (values, venues) => (
  venues && venues.map((venue) => (
    <MenuItem
      key={venue.placeId}
      value={venue.placeId}
      primaryText={venue.placeId}
      checked={values && values.indexOf(venue.placeId) !== -1}
      insetChildren
    />
  ))
);

// eslint-disable-next-line no-shadow
const VenueList = translate(({ input: { onChange }, values, handleVenueChange, venues, translate }) => (
  <div style={styles.wrapper}>
    <div>
      <SelectField
        multiple
        hintText={translate('resources.booking-users.fields.placeId')}
        value={values}
        onChange={(e, i, vals) => {
          const placeString = vals.join(',');
          onChange(placeString);
          handleVenueChange(vals, placeString);
        }}
      >
        {menuItems(values, venues)}
      </SelectField>
    </div>
  </div>
));

export class PlaceSelector extends React.Component {
  constructor(props) {
    super(props);

    let values = get(props.record, props.source);
    values = typeof values === 'string' ? values.split(',') : values;

    this.state = {
      venues: [],
      values,
    };
  }

  componentDidMount = async () => {
    const url = process.env.REACT_APP_API_BASE_URL || 'http://localhost:4042/api';
    const response = await fetch(`${url}/utils/parse/place`, { credentials: 'include' });
    const venues = await response.json();
    this.setState({ venues });
  };

  shouldComponentUpdate = (nextProps, nextState) => !equal(this.props, nextProps) || !equal(this.state, nextState);

  handleVenueChange = (values, placeString) => this.setState({ values, placeString });

  render() {
    const { source } = this.props;
    return (
      <Field
        name={source}
        multiple
        component={(props) => (
          <VenueList
            {...props}
            {...this.state}
            handleVenueChange={this.handleVenueChange}
            handlePreferredChange={this.handlePreferredChange}
          />
        )}
      />
    );
  }
}

const enhance = compose(
  translate
);

export default connect((state) => state)(enhance(PlaceSelector));
